import { StepBasedForm, SuccessPage } from '@components'

import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useSkatConnection } from '@features/vatDeclarations/contexts/skatConnectionContext'
import { IntegrationFormFlow } from '@features/vatDeclarations/enums/integrationFormFlow'
import { SkatIntegrationStatus } from '@features/vatDeclarations/enums/skatIntegrationStatus'

import { useSegment } from '../../../../hooks'
import { InstructionsPage } from './elements/InstructionsPage'

const stepState = {
  [SkatIntegrationStatus.Idle]: '1 - How to',
  [SkatIntegrationStatus.Redirecting]: '2 - Redirecting',
  [SkatIntegrationStatus.Connecting]: '3 - Connecting',
}

export const SkatConnectionView = () => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const { connectionState, isSkatConnected, setConnectionState, setSkatShowConnectionView } = useSkatConnection()

  const handleCloseForm = useCallback(() => {
    setConnectionState(SkatIntegrationStatus.Idle)
    setSkatShowConnectionView(false)
  }, [setConnectionState, setSkatShowConnectionView])

  const handleCancelClick = useCallback(() => {
    handleCloseForm()
    track('xxx - Bookkeeping - DK VAT integration', {
      flow: IntegrationFormFlow.Connect,
      step: stepState[connectionState],
      buttonClick: 'Cancel',
    })
  }, [connectionState, handleCloseForm, track])

  const handleBackClick = useCallback(() => {
    handleCloseForm()
    track('xxx - Bookkeeping - DK VAT integration', {
      flow: IntegrationFormFlow.Connect,
      step: !isSkatConnected ? stepState[connectionState] : '4 - Success',
      buttonClick: 'Back',
    })
  }, [connectionState, handleCloseForm, isSkatConnected, track])

  const handleDoneClick = useCallback(() => {
    handleCloseForm()
    track('xxx - Bookkeeping - DK VAT integration', {
      flow: IntegrationFormFlow.Connect,
      step: '4 - Success',
      buttonClick: 'Done',
    })
  }, [handleCloseForm, track])

  return (
    <StepBasedForm onBack={handleBackClick}>
      {isSkatConnected ? (
        <SuccessPage
          onDoneClick={handleDoneClick}
          headerLabel={t('skat_form.success_header')}
          bodyLabel={t('skat_form.success_body')}
        />
      ) : (
        <InstructionsPage handleCancelClick={handleCancelClick} />
      )}
    </StepBasedForm>
  )
}
